// i18n area 'hci' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.es-ES.meta.json.
import type { enUS } from './hci'

export const esES: typeof enUS = {
  hci: {
    ceph: {
      title: 'Clústeres Ceph',
      createButton: 'Crear clúster Ceph',
      emptyTitle: 'Ningún clúster Ceph gestionado',
      emptyBody: 'TVirt despliega y posee Ceph en los nodos miembros, hiperconvergente con la carga VM. Cree un clúster: el primer monitor y su manager nacen automáticamente en el nodo de control elegido — luego hágalo crecer con más monitores y dispositivos OSD.',
      pageTitle: 'Clústeres Ceph',
      colState: 'Estado',
      colMembers: 'Miembros',
      colSize: 'Tamaño',
      colVersion: 'Versión Ceph',
      sizeCell: '{used} GiB usados de {total} GiB totales',
      phase: {
        'not-deployed': 'No deployado',
        deploying: 'Deploy en curso',
        healthy: 'Saludable',
        degraded: 'Degradado',
        error: 'Error',
        destroying: 'En destrucción',
        destroyed: 'Destruido'
      },
      health: {
        HEALTH_OK: 'Saludable (HEALTH_OK)',
        HEALTH_WARN: 'Con avisos (HEALTH_WARN)',
        HEALTH_ERR: 'En error (HEALTH_ERR)',
        unknown: 'Aún no observada',
        observedAt: 'observada {time}'
      },
      create: {
        title: 'Crear clúster Ceph',
        info: 'Al crear un nuevo clúster Ceph se elige el primer nodo en el que se instalarán los roles MON y MGR. También se especifica qué subnet usar para el tráfico Ceph: la subnet public se usa para el tráfico de red general, mientras que la subnet clúster se usa para las réplicas internas entre los OSD; no hacen falta por fuerza subnets distintas.',
        controlNode: 'Nodo de control',
        controlNodeHint: 'El nodo miembro donde nacen el primer MON + MGR.',
        publicSubnet: 'Subnet public',
        publicSubnetHint: 'Una Subnet registrada en el IPAM — la public_network de Ceph. Inmutable tras la creación.',
        clusterSubnet: 'Subnet clúster',
        clusterSubnetHint: 'Una Subnet registrada en el IPAM — la cluster_network de Ceph (réplica/backfill).',
        noSubnets: 'Ninguna Subnet registrada — créelas primero en el IPAM',
        sameSubnet: 'Misma subnet para el tráfico public y clúster',
        sameSubnetHint: 'Marcada = la red clúster (réplica/backfill) coincide con la public. Sin marcar = elija su propia subnet Y la dirección del nodo de control dentro de ella.',
        controlAddress: 'Dirección del nodo de control',
        controlAddressHint: 'Una dirección que el IPAM conoce para el nodo dentro de la subnet public.',
        controlClusterAddress: 'Dirección clúster del nodo de control',
        controlClusterAddressHint: 'Una dirección que el IPAM conoce para el nodo dentro de la subnet clúster.',
        noAddresses: 'El IPAM no conoce direcciones de este nodo dentro de la subnet elegida',
        started: 'Clúster creado — el bootstrap continúa como macrotask; la fase se actualiza sola',
        error: 'El clúster ha sido rechazado'
      },
      detail: {
        actions: 'Acciones disponibles',
        tabOverview: 'Vista general',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objetos',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avanzado',
        phase: 'Fase',
        checksTitle: 'Checks de salud activos',
        noChecks: 'Ningún check de salud activo',
        checkMuted: 'silenciado',
        summaryPools: 'Pools',
        summaryFilesystems: 'Filesystems',
        nodesCard: 'Nodos',
        monHint: 'Un MGR corre coubicado con cada MON. Tres MON son el quórum recomendado; un clúster de laboratorio arranca con uno. OSD y MDS viven en sus propios tabs.',
        monHintSplit: 'MON y MGR son disjuntos en este clúster (Avanzado): cada rol es una membership propia por nodo. Tres MON son el quórum recomendado; al menos un MGR debe existir.',
        noMons: 'Ningún monitor declarado',
        addNode: 'Añadir nodo',
        removeNode: 'Quitar nodo',
        removeNodeFrom: 'Quitar el nodo {node} (su MON y el MGR coubicado)',
        roleMon: 'Rol MON',
        roleMgr: 'Rol MGR',
        roleNa: 'N/A',
        roleNotObserved: 'aún no observado',
        monInQuorum: 'en quórum',
        monOutQuorum: 'fuera del quórum',
        mgrActive: 'activo',
        mgrStandby: 'standby',
        addRoleMon: 'Añadir rol MON',
        removeRoleMon: 'Quitar rol MON',
        addRoleMgr: 'Añadir rol MGR',
        removeRoleMgr: 'Quitar rol MGR',
        restartMon: 'Reiniciar servicio MON',
        restartMgr: 'Reiniciar servicio MGR',
        addMon: 'Añadir MON',
        removeMon: 'Quitar MON',
        removeMonFrom: 'Quitar el rol MON de {node}',
        addMgr: 'Añadir MGR',
        removeMgr: 'Quitar MGR',
        removeMgrFrom: 'Quitar el rol MGR de {node}',
        addMds: 'Añadir MDS',
        removeMds: 'Quitar MDS',
        removeMdsFrom: 'Quitar el rol MDS de {node}',
        mdsSection: 'Metadata servers (MDS)',
        noMds: 'Ningún MDS declarado — un filesystem requiere uno primero',
        mdsHint: 'La membership MDS es propia desde el primer día: un clúster sin CephFS no declara ninguno, un activo más un standby sirven bien un filesystem. Ceph elige activos y standbys entre los daemons declarados.',
        mdsActiveFor: 'activo — {fs}',
        mdsNotObserved: 'aún no observado',
        lastMdsGuard: 'El último MDS no se puede quitar mientras exista un filesystem — quite primero los filesystems',
        lastMonGuard: 'El último MON no se puede quitar — destruir el clúster es la única salida',
        lastMgrGuard: 'El último MGR no se puede quitar — un clúster gestionado nunca corre sin manager',
        registerDevice: 'Añadir OSD',
        unregisterDevice: 'Desregistrar',
        activeDeviceGuard: 'OSD activo — sale a través del ciclo de vida OSD, no del registro',
        colNode: 'Nodo',
        devicePhase: { registered: 'Registrado', active: 'Activo' },
        health: 'Salud',
        state: 'Estado',
        fsid: 'fsid',
        fsidPending: 'ausente — reintente el bootstrap',
        version: 'Versión Ceph',
        publicNetwork: 'Red public',
        clusterNetwork: 'Red clúster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ninguna acción disponible en esta fase',
        destroyedNote: 'Clúster destruido — la fila se elimina automáticamente en breve'
      },
      overview: {
        services: 'Servicios',
        ok: 'saludable',
        warning: 'warning',
        down: 'caído',
        pgTitle: 'Estados de los PG',
        pgTotal: '{n} PG en total',
        capacityTitle: 'Espacio',
        ioTitle: 'I/O actual',
        ioReadBw: 'Banda de lectura',
        ioWriteBw: 'Banda de escritura',
        ioReadIops: 'IOPS de lectura',
        ioWriteIops: 'IOPS de escritura',
        notObserved: 'aún no observado'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Estado',
        colSize: 'Tamaño',
        colPgs: 'PG',
        empty: 'Ningún OSD — añada uno desde un disco de datos declarado',
        markIn: 'Marcar IN',
        markOut: 'Marcar OUT',
        scrub: 'Ejecutar scrub',
        deepScrub: 'Ejecutar scrub profundo',
        restart: 'Reiniciar servicio',
        details: 'Detalles',
        actionGuard: 'Solo en un OSD activo de un clúster deployado',
        inTitle: 'Marcar OSD IN',
        inBody: 'osd.{id} vuelve a la distribución de los datos (ceph osd in): Ceph rebalancea los datos sobre él.',
        outTitle: 'Marcar OSD OUT',
        outBody: 'osd.{id} sale de la distribución de los datos (ceph osd out): sus datos se rebalancean a otra parte y la redundancia queda REDUCIDA mientras corre el backfill. Reversible en cualquier momento con Marcar IN.',
        scrubTitle: 'Planificar scrub',
        scrubBody: 'Se planifica un scrub de osd.{id}: el mon lo encola y los estados de los PG de los sweeps siguientes cuentan el resultado.',
        deepScrubTitle: 'Planificar scrub profundo',
        deepScrubBody: 'Se planifica un scrub profundo de osd.{id}: la variante que verifica los bytes — más pesada en I/O, misma mecánica.',
        restartTitle: 'Reiniciar servicio OSD',
        restartBody: 'osd.{id} se detiene y se reinicia a través de la supervisión del worker en su nodo.',
        started: 'Acción iniciada — la observación se actualiza sola',
        error: 'La acción OSD ha sido rechazada'
      },
      osdDetail: {
        title: 'Detalles OSD',
        tabGeneral: 'General',
        tabNetwork: 'Red',
        tabDevices: 'Dispositivos',
        version: 'Versión',
        hostname: 'Hostname',
        dataPath: 'Ruta de datos OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Cifrado',
        yes: 'Sí',
        no: 'No',
        memory: 'Uso de memoria (PSS)',
        pid: 'Process ID (PID)',
        front: 'Dirección front (client & monitor)',
        hbFront: 'Dirección heartbeat front',
        back: 'Dirección back (OSD)',
        hbBack: 'Dirección heartbeat back',
        colDevice: 'Device',
        colType: 'Tipo',
        colPhysical: 'Device físico',
        colSize: 'Tamaño',
        volumeTitle: 'Detalles del volumen',
        creationTime: 'Fecha de creación',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ningún device observado para este OSD'
      },
      restart: {
        title: 'Reiniciar servicio',
        monBody: 'El daemon MON en {node} se detiene y se reinicia a través de la supervisión del worker.',
        mgrBody: 'El daemon MGR en {node} se detiene y se reinicia a través de la supervisión del worker.',
        started: 'Reinicio iniciado — la observación se actualiza sola',
        error: 'El reinicio ha sido rechazado'
      },
      encryptionMode: {
        alwaysOn: 'Siempre habilitado (dmcrypt)',
        alwaysOff: 'Siempre deshabilitado',
        perOsd: 'Elegido por cada OSD',
        section: 'Cifrado OSD at rest',
        title: 'Cambiar modo de cifrado OSD',
        hint: 'Cómo se preparan los NUEVOS OSD. Los OSD existentes conservan su estado por disco: para cambiarlo se quita y se recrea el OSD.',
        body: 'El modo pasa a ser "{mode}" y vale SOLO para los NUEVOS OSD: cada OSD existente conserva su estado de cifrado actual.',
        apply: 'Cambiar modo',
        error: 'El cambio de modo ha sido rechazado'
      },
      pin: {
        address: 'Dirección public (pin opcional)',
        clusterAddress: 'Dirección clúster (pin opcional)',
        autoPlaceholder: 'automático en la subnet {cidr}',
        hint: 'Direccionamiento por daemon: vacío = Ceph se engancha solo dentro de la red declarada; con valor = esta instancia queda pinneada a la dirección de su sección de conf.'
      },
      addMon: {
        title: 'Añadir nodo',
        node: 'Nodo',
        address: 'Dirección public',
        addressHint: 'Las direcciones del nodo que el IPAM conoce dentro de la subnet public — automático cuando una declaración existente cubre el nodo.',
        clusterAddress: 'Dirección clúster',
        clusterAddressHint: 'Obligatoria: la subnet clúster es separada y el nodo aún no está declarado en ella.',
        noAddresses: 'El IPAM no conoce direcciones de este nodo dentro de la subnet',
        error: 'La adición del mon ha sido rechazada'
      },
      removeMon: {
        title: 'Quitar MON',
        body: 'El MON y su MGR coubicado dejan el nodo {node}. En un clúster deployado los daemons se detienen y se quitan del quórum.',
        error: 'La retirada del MON ha sido rechazada'
      },
      addMgr: {
        title: 'Añadir MGR',
        node: 'Nodo',
        hint: 'Avanzado (MON/MGR disjuntos): un manager standalone nace en el nodo miembro elegido con un task afín al nodo. La elección active/standby de Ceph escoge sola el MGR activo.',
        error: 'La adición del MGR ha sido rechazada'
      },
      removeMgr: {
        title: 'Quitar MGR',
        body: 'El MGR standalone deja el nodo {node}. En un clúster deployado el daemon se detiene y su estado se elimina; el MON del nodo (si existe) no se toca.',
        error: 'La retirada del MGR ha sido rechazada'
      },
      addMds: {
        title: 'Añadir MDS',
        node: 'Nodo',
        hint: 'El metadata server de CephFS: nace en el nodo miembro elegido con un task afín al nodo, supervisado por el worker como MON y MGR. Ceph elige solo activos y standbys — un activo más un standby sirven bien un filesystem.',
        error: 'La adición del MDS ha sido rechazada'
      },
      removeMds: {
        title: 'Quitar MDS',
        body: 'El MDS deja el nodo {node}. En un clúster deployado el daemon se detiene y su estado se elimina; la API rechaza el último MDS mientras un filesystem lo necesite.',
        error: 'La retirada del MDS ha sido rechazada'
      },
      split: {
        title: 'MON/MGR disjuntos',
        label: 'Permitir MON y MGR en nodos disjuntos',
        hint: 'Apagado (default) = el estándar ratificado: un MGR corre coubicado con cada MON, una sola membership. Encendido = la membership de los MGR pasa a ser propia, gestionada con las acciones Añadir/Quitar MGR en el tab Nodos de gestión.',
        enable: 'Activar',
        disable: 'Desactivar',
        enableBody: 'La membership de los MGR se vuelve independiente de los MON, inicializada desde la coubicación actual. Las acciones Añadir/Quitar MGR se arman en el tab Nodos de gestión. Esto relaja el default de plataforma — manténgalo solo si sabe por qué lo necesita.',
        disableBody: 'Vuelta a la coubicación estándar: un MGR con cada MON, una sola membership. Legal solo si la membership de los MGR ya coincide con los MON — alinéela primero con Añadir/Quitar MGR, o la API rechazará.',
        error: 'El cambio ha sido rechazado'
      },
      rawEditor: {
        title: 'Editor CRUSH en bruto',
        label: 'Mostrar el editor en bruto de la crushmap en el tab CRUSH',
        hint: 'Apagado (default) = la superficie guiada de reglas es la herramienta estándar. Encendido = el tab CRUSH muestra también la crushmap decompilada como texto editable. El guardado requiere siempre sudo, el nombre del clúster como confirmación, y pasa por compile + test de crushtool ANTES de llegar al clúster.'
      },
      osdFlags: {
        section: 'Flags OSD globales',
        title: 'Override de flags OSD',
        notObserved: 'aún no observados',
        standardFlowsHint: 'Los flujos estándar de la plataforma gestionan estos flags solos en los casos normales (el mantenimiento de un nodo pone un noout acotado, la sustitución de disco pasa por el ciclo de vida OSD). Esta sección es el override manual para el operador que sabe lo que hace.',
        notDeployedGuard: 'Los flags OSD existen solo en un clúster deployado',
        set: 'Establecer flag',
        unset: 'Quitar flag',
        setBody: 'El flag global {flag} se ESTABLECERÁ en el osdmap. Permanece hasta que se quite explícitamente — un flag olvidado degrada la autorreparación del clúster.',
        unsetBody: 'El flag global {flag} se QUITARÁ del osdmap.',
        error: 'El cambio del flag ha sido rechazado',
        flag: {
          noout: 'Ningún OSD se marca out de la distribución de los datos — sin rebalanceo al perder un daemon',
          norebalance: 'El rebalanceo de los datos está suspendido',
          nobackfill: 'El backfill está suspendido',
          norecover: 'El recovery está suspendido',
          pause: 'TODO el I/O de los clients está en pausa (lecturas y escrituras)',
          noin: 'Los OSD que arrancan no se marcan in automáticamente',
          nodown: 'Los OSD inalcanzables no se marcan down — enmascara fallos reales'
        }
      },
      pools: {
        section: 'Pools',
        create: 'Crear pool',
        createGuard: 'Los pools existen solo en un clúster deployado',
        notObserved: 'Ninguna observación de los pools — el sweep del mon reporta aquí',
        empty: 'Ningún pool en el clúster',
        colName: 'Nombre',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplicación',
        colRule: 'Regla CRUSH',
        colUsage: 'Uso',
        observedAtLabel: 'Observado el',
        objects: '{n} objetos',
        inUseBy: 'en uso por {name}',
        internalGuard: 'Pool interno de Ceph — la plataforma nunca lo elimina',
        delete: 'Eliminar pool',
        deleteGuard: 'Consumido por el storage {name} — elimine primero el storage',
        hint: 'Solo pools replicados (erasure coding fuera de scope v1). La réplica vive en Ceph: esta tabla es la verdad observada por el sweep del mon.',
        createTitle: 'Crear pool',
        createHint: 'El pool nace en el clúster con la réplica pedida y la aplicación rbd habilitada — el trabajo lo hace un task en un nodo MON. Encienda "Proponer como storage" para consumirlo enseguida en el mismo gesto.',
        name: 'Nombre del pool',
        nameHint: 'DNS-safe (minúsculas, cifras, guiones).',
        size: 'Réplicas (size)',
        sizeHint: 'Copias de cada objeto. Default 3.',
        minSize: 'Réplicas mínimas (min_size)',
        minSizeHint: 'Copias mínimas para servir I/O — sigue size − 1 hasta que lo modifique.',
        createError: 'La creación del pool ha sido rechazada',
        deleteTitle: 'Eliminar pool',
        deleteBody: 'El pool {pool} y CADA objeto dentro de él se destruyen irreversiblemente. Escriba el nombre del pool para confirmar.',
        confirmLabel: 'Nombre del pool',
        confirmHint: 'Escriba el nombre del pool para confirmar',
        deleteError: 'La eliminación del pool ha sido rechazada',
        detailTitle: 'Detalles del pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Activo',
        autoscalerOff: 'No activo',
        autoscalerWarn: 'Notificar',
        pgNumLabel: 'Número de PG',
        pgNumCaption: 'Observado: el autoscaler puede cambiarlo por su cuenta — este campo escribe un deseo.',
        storage: 'Storage TVirt asociado',
        addAsStorage: 'Añadir como storage TVirt',
        ruleSudoHint: 'El cambio de la regla CRUSH requiere la contraseña del operador.',
        updateError: 'La modificación del pool ha sido rechazada',
        updated: 'Modificación del pool iniciada — la observación se actualiza sola'
      },
      crush: {
        section: 'Reglas CRUSH',
        notObserved: 'Ninguna observación CRUSH todavía — el sweep del mon reporta aquí',
        empty: 'Ninguna regla observada en el clúster',
        hint: 'Una regla decide DÓNDE acaban las copias de cada objeto — su dominio de fallo es la unidad que puede fallar sin perder datos. Los pools apuntan a una regla; la replicated_rule builtin (una réplica por servidor) es el default de nacimiento.',
        create: 'Crear regla',
        createGuard: 'Las reglas CRUSH existen solo en un clúster deployado',
        createTitle: 'Crear regla CRUSH',
        createHint: 'Una regla = una elección de dominio de fallo. La regla nace replicada en el root de default — el trabajo lo hace un task en un nodo MON; asocie los pools desde el tab Pools después.',
        createError: 'La creación de la regla ha sido rechazada',
        name: 'Nombre de la regla',
        nameHint: 'DNS-safe (minúsculas, cifras, guiones).',
        domain: 'Dominio de fallo',
        domainChoice: {
          osd: 'Cada réplica en un OSD distinto',
          host: 'Cada réplica en un servidor distinto',
          rack: 'Cada réplica en un rack distinto'
        },
        domainCustom: 'Personalizada (steps escritos a mano)',
        domainOther: 'Cada réplica en un {type} distinto',
        rackGuardHint: 'Ningún bucket rack existe en la jerarquía observada: la regla puede crearse igualmente, pero ningún pool podrá apuntarla hasta que un rack esté declarado en el emplazamiento de los servidores miembros (ajustes del nodo) — el task de realineación construye el bucket y la asociación se abre sola.',
        treeTitle: 'Jerarquía observada',
        treeNotObserved: 'Ninguna observación de la jerarquía — el sweep del mon reporta aquí',
        treeOsds: '{n} OSD',
        treeHint: 'El mapa CRUSH como lo ve el clúster: root → niveles declarados → servidores (hosts) → OSD. La topología sigue el emplazamiento declarado de cada servidor (ajustes del nodo) — un cambio de posición la realinea vía task.',
        unplacedWarning: 'Miembros sin posición declarada: {nodes} — sus hosts quedan directamente bajo la root, fuera de la topología declarada. Declare la posición en los ajustes del nodo (un aviso, nunca un bloqueo).',
        colName: 'Nombre',
        colDomain: 'Dominio de fallo',
        colPools: 'Pools',
        builtinChip: 'builtin',
        builtinGuard: 'La regla de default del clúster — la plataforma nunca la elimina',
        detailAction: 'Detalle de la regla',
        detailType: 'Tipo',
        backToRules: 'Reglas',
        ruleNotObserved: 'La lista observada de reglas no nombra esta regla',
        noPools: 'Ningún pool cabalga esta regla',
        delete: 'Eliminar regla',
        deleteTitle: 'Eliminar regla CRUSH',
        deleteBody: 'La regla {rule} se elimina de la crushmap del clúster. Ningún pool debe cabalgarla. Escriba el nombre de la regla para confirmar.',
        deleteGuard: 'Cabalgada por el pool {name} — reapunte primero el pool',
        confirmLabel: 'Nombre de la regla',
        confirmHint: 'Escriba el nombre de la regla para confirmar',
        deleteError: 'La eliminación de la regla ha sido rechazada',
        changeRule: 'Cambiar regla CRUSH',
        changeRuleTitle: 'Cambiar regla CRUSH',
        changeRuleHint: 'El pool empieza a colocar sus objetos según la regla elegida — Ceph mueve los datos existentes para conformarse (en un pool lleno sigue un rebalanceo).',
        changeRuleError: 'El cambio de regla ha sido rechazado',
        rule: 'Regla CRUSH',
        rawTitle: 'Crushmap en bruto (decompilada)',
        rawWarning: 'PELIGRO: este texto es TODA la política de colocación del clúster. Un mapa equivocado puede romper el placement de todos los pools a la vez. El guardado compila y prueba el mapa con crushtool ANTES de inyectarlo — pero un mapa válido puede seguir siendo una mala idea.',
        rawReload: 'Recargar',
        rawLoading: 'Query en vuelo — un task read-only está decompilando la crushmap…',
        rawSave: 'Guardar crushmap',
        rawSaveTitle: 'Inyectar crushmap',
        rawSaveBody: 'El texto editado sustituye la crushmap del clúster ENTERO tras compile + test de crushtool. Escriba el nombre del clúster para confirmar.',
        rawConfirmLabel: 'Nombre del clúster',
        rawConfirmHint: 'Escriba {name} para confirmar',
        rawError: 'La operación sobre la crushmap ha fallado',
        rawHint: 'El texto es la forma crushtool -d. Los errores de compilación y de test vuelven palabra por palabra de crushtool — el mapa no llega al clúster si una de las dos puertas falla.'
      },
      objects: {
        poolsSection: 'Explorador de objetos',
        poolsHint: 'Elija un pool para listar sus imágenes RBD. Cada lectura profunda corre como task read-only en un nodo MON — no bloquea (ni es bloqueada por) las operaciones reales.',
        deployedGuard: 'Las queries sobre objetos responden solo en un clúster deployado',
        browse: 'Explorar los objetos',
        detailAction: 'Detalle de la imagen',
        backToPools: 'Pools',
        backToImages: 'Imágenes',
        refresh: 'Actualizar',
        loading: 'Query en vuelo — un task read-only está interrogando el clúster…',
        error: 'La query ha fallado',
        retry: 'Reintentar',
        notRbd: 'Pool con application "{app}" — no contiene imágenes RBD, nada que explorar aquí',
        noImages: 'Ninguna imagen RBD en este pool',
        colImage: 'Imagen',
        colSize: 'Tamaño',
        colObjects: 'Objetos',
        colSnapshots: 'Snapshots',
        imagesHint: 'Los discos en un storage rbd consumidor son imágenes con el nombre de su id de disco. El conteo de objetos es el provisioned (tamaño / tamaño de objeto) — el uso real vive en el detalle de la imagen.',
        infoTitle: 'Imagen',
        infoSize: 'Tamaño virtual',
        infoObjects: 'Objetos (provisioned)',
        infoObjectSize: 'Tamaño de objeto',
        infoPrefix: 'Prefijo de objetos',
        infoFormat: 'Formato',
        infoFeatures: 'Features',
        usageTitle: 'Uso real (rbd du)',
        usageOf: 'de {provisioned} GiB provisioned',
        usageHint: 'Thin por naturaleza: solo los objetos escritos ocupan bytes.',
        watchersTitle: 'Watchers',
        noWatchers: 'Ningún watcher — nadie tiene esta imagen abierta ahora',
        snapshotsTitle: 'Snapshots RBD',
        noSnapshots: 'Ningún snapshot RBD en esta imagen',
        colSnapshot: 'Snapshot',
        colProtected: 'Protegido',
        colTimestamp: 'Creado',
        protected: 'protegido',
        mappingTitle: 'Mapeo físico (conjunto OSD)',
        mappingSampled: 'Muestra de {sampled} objetos sobre {total} — resumen honesto: para imágenes grandes el conjunto converge a TODOS los OSD del pool (CRUSH distribuye los objetos por todo el pool).',
        mappingComplete: 'Todos los objetos mapeados ({total} de {total}).',
        objectQueryTitle: 'Mapear un solo objeto',
        objectName: 'Nombre del objeto',
        objectHint: 'Los nombres de objeto RADOS son <prefijo>.<índice 16-hex> — ceph osd map responde con el PG y las ternas OSD.',
        mapObject: 'Mapear',
        primary: 'primario: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrar dispositivo OSD',
        hint: 'En un clúster vivo el registro también PREPARA el dispositivo: se convierte en un OSD BlueStore con un task automático afín al nodo (nunca vacío, ratificado 2026-07-24). Un dispositivo pertenece como mucho a un clúster Ceph en toda la flota.',
        disk: 'Disco de datos',
        diskHint: 'Los discos de datos declarados del nodo — nombre y serial',
        noDeclared: 'Ningún disco de datos declarado en este nodo — márquelos primero en los ajustes locales del nodo',
        serialHint: 'El serial del dispositivo — el pin de identidad',
        encrypted: 'Cifrar este OSD (dmcrypt)',
        encryptedHint: 'La elección por OSD (el modo del clúster es "elegido por cada OSD"): se congela en este disco al registrarlo — un cambio de modo posterior nunca la reescribe; lo hace la acción de fila cifrar/descifrar.',
        error: 'El registro ha sido rechazado'
      },
      unregisterDevice: {
        title: 'Desregistrar dispositivo',
        body: 'Solo registro: {name} deja de ser un candidato OSD de este clúster. Sus bytes no se tocan.',
        error: 'El desregistro ha sido rechazado'
      },
      deploy: {
        action: 'Reintentar deploy',
        title: 'Reintentar el bootstrap',
        body: 'El bootstrap de nacimiento vuelve a partir de la configuración actual: los mons arrancan, cada dispositivo registrado se prepara y se activa como OSD BlueStore. La operación corre como macrotask — la fase se actualiza sola.',
        started: 'Bootstrap iniciado — continúa como macrotask; la fase se actualiza sola',
        error: 'El bootstrap ha sido rechazado'
      },
      propose: {
        action: 'Proponer como storage',
        title: 'Proponer como storage',
        hintPool: 'El pool existente {name} se convierte en un storage TVirt: una identidad cephx limitada al pool acaba en el keystore y el storage ceph-rbd nace listo. La propuesta consume el pool — nunca crea uno.',
        hintFs: 'El filesystem existente {name} se convierte en un storage TVirt: una identidad cephx limitada al filesystem acaba en el keystore y el storage cephfs nace listo y montado. La propuesta consume el filesystem — nunca crea uno.',
        name: 'Nombre del storage',
        nameHint: 'DNS-1123, único en el scope — la identidad cephx toma su nombre de él.',
        path: 'Path dentro del filesystem',
        pathHint: 'Path absoluto dentro del filesystem que el storage monta — / en caso de duda.',
        alsoPropose: 'Proponer enseguida como storage',
        alsoProposePoolHint: 'Tras la creación el mismo gesto propone el pool recién nacido como storage ceph-rbd — dos llamadas explícitas, un solo dialog.',
        alsoProposeFsHint: 'Tras la creación el mismo gesto propone el filesystem recién nacido como storage cephfs — dos llamadas explícitas, un solo dialog.',
        guard: 'Proponer como storage — solo en un clúster healthy',
        started: 'Propuesta aceptada — el storage se está materializando; lo encontrará bajo Storage',
        submit: 'Crear storage',
        error: 'La propuesta ha sido rechazada'
      },
      fs: {
        section: 'Filesystems',
        create: 'Crear filesystem',
        createGuard: 'Los filesystems existen solo en un clúster deployado',
        mdsFirstGuard: 'Añada primero un MDS — un filesystem sin metadata server nace inservible',
        notObserved: 'Ninguna observación de los filesystems — el sweep del MON reporta aquí',
        empty: 'Ningún filesystem en el clúster',
        colName: 'Nombre',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'ningún MDS activo',
        delete: 'Quitar filesystem',
        deleteGuard: 'Consumido por el storage {name} — elimine primero el storage',
        hint: 'Un filesystem posee sus pools de datos y metadata (cephfs.<nombre>.data / .meta): nacen con él y mueren con él — removeFs, nunca un delete de pool a mano. Esta tabla es la verdad observada por el sweep del MON.',
        createTitle: 'Crear filesystem',
        createHint: 'El filesystem nace en el clúster con sus dos pools (application cephfs) y es servido por los MDS declarados — el trabajo lo hace un task en un nodo MON. Encienda "Proponer como storage" para consumirlo enseguida en el mismo gesto.',
        name: 'Nombre del filesystem',
        nameHint: 'DNS-safe (minúsculas, cifras, guiones).',
        sizeHint: 'Réplicas de AMBOS pools nacientes. Default 3.',
        createError: 'La creación del filesystem ha sido rechazada',
        deleteTitle: 'Quitar filesystem',
        deleteBody: 'El filesystem {fs} y CADA archivo dentro de él se destruyen irreversiblemente — sus pools de datos y metadata mueren con él. Escriba el nombre del filesystem para confirmar.',
        confirmLabel: 'Nombre del filesystem',
        confirmHint: 'Escriba el nombre del filesystem para confirmar',
        deleteError: 'La retirada del filesystem ha sido rechazada'
      },
      destroy: {
        action: 'Destruir',
        retryAction: 'Reintentar la eliminación',
        retryGuard: 'La destrucción está corriendo — el retry vale para una destrucción fallida (el lease lo rechaza en caso contrario)',
        title: 'Destruir el clúster',
        body: 'El fabric deployado se desmantela: cada daemon de este clúster se detiene, su estado de sistema y las claves del keystore se liberan. Con la destrucción lograda el clúster se elimina automáticamente.',
        confirmLabel: 'Nombre del clúster',
        confirmHint: 'Escriba el nombre del clúster para confirmar',
        wipe: 'Borrar los dispositivos registrados',
        wipeHint: 'Marcada: las firmas de cada dispositivo registrado se borran — los datos encima quedan destruidos. Sin marcar: los bytes quedan intactos y los dispositivos vuelven a registrados.',
        guard: 'Destruir — nada deployado',
        started: 'Destrucción iniciada — continúa como macrotask; la fase se actualiza sola',
        error: 'La destrucción ha sido rechazada'
      },
      delete: {
        guard: 'Eliminar — solo una configuración no deployada (destruya primero)',
        title: '¿Eliminar {name}?',
        body: 'La configuración y su registro de dispositivos se eliminan. Legal solo mientras nada esté deployado.',
        error: 'La eliminación ha sido rechazada'
      }
    }
  }
}
